import Vue from 'vue';
import Vuex, {Store} from 'vuex';
import {AscDesc, ResultType, XHTTPService} from '@/shared/xhttp';
import {
	PaginatorFilterState,
	PaginatorActionWithFilters,
	PaginatorMutation,
	StandardAction,
} from '@/shared/utils';
import {Projet} from '@/models';
import {ProjetService} from "@/xhttp/ProjetService";

import {DateFilter} from '@/shared/filter';
import store from '@/stores';

Vue.use(Vuex);

export class ProjetFilter {

	name: string = '';
	email: string = '';
	remarques: string = '';
	address: string = '';
	zipCode: string = '';
	town: string = '';
	country: string = '';

	public clear(): void {
		this.name = '';
		this.email = '';
		this.remarques = '';
		this.address = '';
		this.zipCode = '';
		this.town = '';
		this.country = '';
	}

	public toString(): string {
		return JSON.stringify(this);
	}
}

class ProjetState extends PaginatorFilterState<ProjetFilter> {
	projet: Projet = null;
	projets: ResultType<Projet> = null;
	public constructor() {
		super(new ProjetFilter(), 'projets', 'projet', 'id', AscDesc.DESC, 20)
	}
}

class ProjetStore {

	@XHTTPService(() => Projet)
	private projetService: ProjetService;
	private  _store: Store<any>;

	public state: ProjetState = new ProjetState();

	public mutations = {
		...PaginatorMutation(() => this._store, 'projets', 'projet'),
	};

	public actions = {
		...StandardAction<Projet, ProjetState>(() => Projet, 'projet'),
		...PaginatorActionWithFilters<Projet, ProjetState>(() => Projet, 'projets', 'projet'),
	};

	public init(store: Store<any>): this {
		this._store = store;
		return this;
	}

}

const instance = new ProjetStore();
const storeProjet = new Vuex.Store(instance);
instance.init(storeProjet);

const instancePrix = new ProjetStore();
export const storeProjetPrix = new Vuex.Store(instancePrix);
instancePrix.init(storeProjetPrix);

store.registerModule('projet', storeProjet);
store.registerModule('projetPrix', storeProjetPrix);
export default storeProjet;